import InvestorVerificationPreview from './InvestorVerificationPreview.page';

export default InvestorVerificationPreview;
